import { render, staticRenderFns } from "./RoomAssignments.vue?vue&type=template&id=6b25d295&scoped=true&"
import script from "./RoomAssignments.vue?vue&type=script&lang=js&"
export * from "./RoomAssignments.vue?vue&type=script&lang=js&"
import style0 from "./RoomAssignments.vue?vue&type=style&index=0&id=6b25d295&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25d295",
  null
  
)

export default component.exports